import React, { useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import BootstrapTable from "react-bootstrap-table-next";
import { Link, NavLink, useLocation, useParams } from "react-router-dom";
import ReactPaginate from "react-paginate";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import moment from "moment";
import Swal from "sweetalert2/dist/sweetalert2.js";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Spinner,
  Badge,
  UncontrolledTooltip,
  Modal,
  Button,
} from "reactstrap";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import { postRequest } from "components/Common/Utils";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const ConfirmOrderAssign = () => {
  ///order nearBy
  const history = useHistory();
  const _id = useParams();
  const [Bannerdata, setBannerdata] = useState([]);
  const [value, setValue] = React.useState(10);
  const [sort, setsort] = React.useState("name");
  const [currentFPage, setCurrentFPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [sizePerPageOrg, setSizePerPage] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [loader, setLoader] = useState(false);
  const [userAllDetails, setuserAllDetails] = useState({});
  const [orderDataInfo, setOrderSelectedInfo] = useState({});
  const [selectedProductsData, setselectedProductsData] = useState([]);
  const [manufacturersType, setManufacturers] = useState("");

  // warehouse selection
  const [warehouses, setWarehouses] = useState([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);
  const [warehouseLoader, setWarehouseLoader] = useState(false);

  const fetchWarehouses = async () => {
    try {
      setWarehouseLoader(true);
      const response = await postRequest("warehouse/list", {
        page: 1,
        limit: 10,
      });
      const warehouseList = response.data?.list || [];
      setWarehouses(warehouseList);
      // Set first warehouse as default selected
      if (warehouseList.length > 0 && !selectedWarehouse) {
        setSelectedWarehouse(warehouseList[0]);
      }
      setWarehouseLoader(false);
    } catch (error) {
      setWarehouseLoader(false);
      console.error("Error fetching warehouses:", error);
    }
  };

  useEffect(() => {
    fetchWarehouses();
  }, []);

  // Function to handle warehouse change
  const handleWarehouseChange = (e) => {
    const selectedId = e.target.value;
    const warehouse = warehouses.find((w) => w._id === selectedId);
    setSelectedWarehouse(warehouse);
  };

  const location = useLocation();
  useEffect(() => {
    fetchOrderlist();
  }, [currentPage]);

  useEffect(() => {
    // console.log(location?.state?.row);
    setuserAllDetails(location?.state?.row);
    console.log(location?.state?.selectedProductsData);
    setselectedProductsData(location?.state?.selectedProductsData);
    setOrderSelectedInfo(location?.state?.orderInfo);
    setManufacturers(location?.state?.manufacturersType);
    console.log(location?.state);
  }, [location.state]);

  const handleTableChange = (type, { page, sizePerPage, searchText }) => {
    if (type === "pagination") {
      if (page != currentPage) {
        setCurrentPage(page);
        console.log("page", page);
      }
    }

    console.log("type", type);

    if (type === "search") {
      console.log("searchText", searchText);
    }
  };

  const defaultSorted = [
    {
      dataField: "_id",
      order: "asc",
    },
  ];

  function SNoFormatter(cellContent, row, i) {
    return <>{i + 1}</>;
  }

  function ShopFirstFormatter(cellContent, row) {
    return (
      <div className="d-flex gap-2">
        <div className="flex-product">
          {row?.userDetail?.first_name + " " + row?.userDetail?.last_name}
          {/* {row?.userDetails?.last_name} */}
        </div>
      </div>
    );
  }
  function UserTypeFormatter(cellContent, row) {
    return (
      <div className="d-flex gap-2">
        <div className="flex-product">
          {row?.userDetails?.type === "user" ? (
            <>SME</>
          ) : (
            <>Informal Retailer</>
          )}
        </div>
      </div>
    );
  }
  function ProductFormatter(cellContent, row) {
    return (
      <div className="d-flex gap-2 justify-content-center">
        <div className="flex-product">
          {row?.deliveryAddress?.addressLine1}&nbsp;
          {row?.deliveryAddress?.addressLine2}
        </div>
      </div>
    );
  }
  function OrderStatusFormatter(cellContent, row) {
    return (
      <div className="">
        <div className="status-order">
          <h5
            style={{
              color:
                row?.orderStatus === "pending"
                  ? "#FFC107"
                  : row?.orderStatus === "cancelled"
                  ? "#ec536c"
                  : "#4caf50", // Default color for other statuses
            }}
          >
            {row?.orderStatus}
          </h5>
        </div>
      </div>
    );
  }
  function PaymentStatusFormatter(cellContent, row) {
    return (
      <div className="">
        <div className="status-order">
          <h5
            style={{
              color:
                row?.paymentStatus === "completed" ||
                row?.paymentStatus === "Paid"
                  ? "#4caf50"
                  : row?.paymentStatus === "Cancelled"
                  ? "#ec536c"
                  : "#FFC107",
            }}
          >
            {row?.paymentStatus}
          </h5>
        </div>
      </div>
    );
  }
  function PaymentStatusFormatter2(row) {
    return (
      <div className="">
        <div className="status-order">
          <h5
            style={{
              color:
                row === "completed" || row === "Paid"
                  ? "#4caf50"
                  : row === "Cancelled"
                  ? "#ec536c"
                  : "#FFC107",
            }}
          >
            {row}
          </h5>
        </div>
      </div>
    );
  }

  function iconFormatter2(cellContent, row) {
    return (
      <div className="d-flex gap-2">
        <button type="button" className=" btn btn-primary">
          <Link
            to={{
              pathname: `/user-order-details/${row?._id}`,
              // pathname: `/user-order-details`,
              state: { row },
            }}
          >
            <i className="fal fa-eye fs-5 text-light"></i>
          </Link>
        </button>
      </div>
    );
  }
  function TotalAmountFormatter(cellContent, row) {
    return (
      <div className="">
        <div className="flex-product">${row?.grandTotal}</div>
      </div>
    );
  }
  function OrderDateFormatter(cellContent, row) {
    return (
      <div
        className="d-flex gap-2 align-items-center"
        style={{ whiteSpace: "nowrap" }}
      >
        {moment(row.createdAt).format("DD/MM/YYYY hh:mm")}
      </div>
    );
  }

  const columns = [
    {
      text: "S.NO",
      formatter: SNoFormatter,
      sort: false,
    },
    {
      dataField: "_id",
      text: "Order Id",
      sort: false,
    },
    {
      text: "User Name",
      sort: false,
      formatter: ShopFirstFormatter,
    },
    {
      text: "Order Address",
      sort: false,
      formatter: ProductFormatter,
    },
    {
      text: "User Type",
      sort: false,
      formatter: UserTypeFormatter,
    },
    {
      // dataField: "orderStatus",
      text: "Order Status",
      sort: false,
      formatter: OrderStatusFormatter,
    },
    {
      // dataField: "orderStatus",
      text: "Payment Status",
      sort: false,
      formatter: PaymentStatusFormatter,
    },
    {
      formatter: TotalAmountFormatter,
      //dataField: "totalAmount",
      text: "Grand Total",
      sort: false,
    },
    {
      text: "Order Date",
      formatter: OrderDateFormatter,
      sort: false,
    },
    {
      dataField: "actions",
      text: "Action",
      formatter: iconFormatter2,
      sort: false,
    },

    // {
    //     dataField: "select",
    //     text: "Select",
    //     formatter: iconFormatter,
    //     sort: false,
    // },
  ];

  const limit = 10;

  const fetchOrderlist = async (page = 0) => {
    setLoader(true);
    const payload = {
      limit: 100,
      page: currentPage,
      sortField: sort,
      orderId: _id?.id,
      sortOrder: "asc",
    };
    if (searchText) {
      payload.search = searchText;
    }
    const response = await postRequest(`order/nearby-pending-orders`, payload);
    const data = response?.data;
    //console.log("data", data, response)
    setTotalPage(1);
    // setTotalPage(data?.count);
    setCurrentFPage(data?.page);
    setBannerdata(data?.list || []);
    setLoader(false);
  };

  // selected nearBy orders
  const [selectedData, setSelectedData] = useState({});
  const [selectedProductData, setSelectedProductData] = useState([]);
  const handleSelectAll = (e, row) => {
    const orderId = row._id; // Use `orderId` as the key
    if (!orderId) return console.error("Order ID is missing:", row);

    if (e.target.checked) {
      const pendingProductIds =
        row?.products
          ?.filter((item) => item.deliveryStatus === "pending")
          .map((item) => item.productId) || [];

      const pendingProduct =
        row?.products
          ?.filter((item) => item.deliveryStatus === "pending")
          .map((item) => item) || [];

      setSelectedProductData((prev) => [...prev, ...pendingProduct]);

      setSelectedData((prev) => ({
        ...prev,
        [orderId]: {
          orderId,
          productIds: pendingProductIds,
        },
      }));
    } else {
      setSelectedData((prev) => ({
        ...prev,
        [orderId]: {
          orderId: "",
          productIds: [],
        },
      }));
      setSelectedProductData((prev) =>
        prev.filter((item) => !row.products.includes(item))
      );
    }
  };

  const handleSelectOne = (e, productId, orderId, item) => {
    setSelectedData((prev) => {
      const selectedOrder = prev[orderId] || { orderId, productIds: [] };
      let updatedProductIds;
      if (e.target.checked) {
        updatedProductIds = [...selectedOrder.productIds, productId];
      } else {
        updatedProductIds = selectedOrder.productIds.filter(
          (id) => id !== productId
        );
      }
      return {
        ...prev,
        [orderId]: { orderId, productIds: updatedProductIds },
      };
    });
    setSelectedProductData((prev) => {
      if (e.target.checked) {
        return [...prev, item]; // Add product item
      } else {
        return prev.filter((p) => p.productId !== productId); // Remove product item
      }
    });
  };

  const expandRow = {
    // onlyOneExpanding: true,
    nonExpandable: [],
    expandBy: "columnOnly",
    showExpandColumn: true,
    parentClassName: "parent-expand-foo",
    renderer: (row) => (
      <div>
        <table className="table table-bordered table-striped">
          <thead>
            <tr>
              <th>
                <input
                  type="checkbox"
                  style={{ height: "20px", width: "21px", cursor: "pointer" }}
                  onChange={(e) => handleSelectAll(e, row)}
                  checked={
                    row?.products?.length > 0 &&
                    (selectedData[row?._id]?.productIds?.length || 0) ===
                      row?.products?.filter(
                        (item) => item?.deliveryStatus === "pending"
                      )?.length
                  }
                />
              </th>
              <th tabIndex={0}>S.NO</th>
              <th tabIndex={0}>Manufacturer Info</th>
              <th tabIndex={0}>Product Image</th>
              <th tabIndex={0}>Product Name</th>
              {/* <th tabIndex={0}>Description	</th> */}
              <th tabIndex={0}>Quantity</th>
              <th tabIndex={0}>Price</th>
              <th tabIndex={0}>Total Amount</th>
            </tr>
          </thead>
          <tbody>
            {row?.products?.map((item, index) => {
              const isFirstSelected =
                selectedData.length > 0 && selectedData[0] === item.productId;
              return (
                <>
                  <tr key={index}>
                    <td>
                      {item?.deliveryStatus !== "assigned" && (
                        <input
                          type="checkbox"
                          style={{
                            height: "20px",
                            width: "20px",
                            cursor: "pointer",
                          }}
                          checked={selectedData[row?._id]?.productIds?.includes(
                            item.productId
                          )}
                          onChange={(e) =>
                            handleSelectOne(e, item.productId, row._id, item)
                          }
                        />
                      )}
                    </td>
                    <td>{index + 1}</td>
                    <td>
                      <div className="d-flex gap-2 align-items-center">
                        <Link
                          to={`/manufacturers-details/${item?.manufacturer?._id}`}
                        >
                          <div style={{ width: "50px" }}>
                            <img src={item?.manufacturer?.logo} width="50px" />
                          </div>
                        </Link>
                        <div className="flex-product text-start">
                          <Link
                            to={`/manufacturers-details/${item?.manufacturer?._id}`}
                            className="mb-0"
                          >
                            {item?.manufacturer?.companyName}
                          </Link>
                          {/* <p className="mb-0">{item?.manufacturer?.mobile}, </p> */}
                          <p className="mb-0">{item?.manufacturer?.address}</p>
                        </div>
                      </div>
                    </td>
                    <td>
                      <img
                        src={item?.images?.[0]}
                        alt="Not found Product"
                        width="50px"
                      />
                    </td>
                    <td>{item?.name}</td>
                    <td>{item?.quantity}</td>
                    <td>${item?.price}</td>
                    <td>${item?.totalPrice}</td>
                  </tr>
                </>
              );
            })}
          </tbody>
        </table>
      </div>
    ),
    showExpandColumn: true,
    expandHeaderColumnRenderer: ({ isAnyExpands }) => (
      <button
        type="button"
        className="btn btn-danger"
        style={{ display: "none" }}
      >
        <i className={`fal fa-${isAnyExpands ? "minus" : "plus"} fs-5`}></i>
      </button>
    ),
    expandColumnRenderer: ({ expanded }) => (
      <button type="button" className="btn btn-danger">
        <i className={`fal fa-${expanded ? "minus" : "plus"} fs-5`}></i>
      </button>
    ),
  };

  const handleApproved = async () => {
    try {
      // setLoader(true);
      const metaData = Object.values(selectedData).map((value) => ({
        orderId: value.orderId,
        productIds: value.productIds,
      }));
      const payload = {
        type: "specific",
        productIds: selectedProductsData?.map((item) => item.productId),
        orderId: orderDataInfo?.orderId,
        deliveryAgentId: userAllDetails?._id,
        // warehouseId: orderDataInfo?.warehouseId,
        warehouseId: selectedWarehouse?._id,

        metaData,
      };
      const response = await postRequest(
        "order/assign-to-delivery-agent",
        payload
      );
      console.log(response?.status);
      if (response?.status) {
        setLoader(false);
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Order successfully assigned to the delivery agent!",
          confirmButtonText: "OK",
        }).then(() => {
          history.push(`/user-order-details/${orderDataInfo?.orderId}`);
        });
      } else {
        throw new Error("Failed to assign order. Please try again.");
      }
    } catch (error) {
      setLoader(false);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "Something went wrong!",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <Row>
        <Col className="10">
          <div className="page-title-box">
            <h4>Order Management</h4>
            <ol className="breadcrumb m-0">
              <li className="breadcrumb-item active">Order Management</li>:{" "}
              <li className="breadcrumb-item">Confrim Order Assign</li>
            </ol>
          </div>
        </Col>
      </Row>

      <Card className="cartPage">
        {loader ? (
          <CardBody style={{ height: "100px" }}>
            <Spinner
              color="info"
              style={{
                height: "4rem",
                width: "4rem",
                position: "absolute",
                left: "50%",
              }}
            >
              Loading...
            </Spinner>
          </CardBody>
        ) : (
          <>
            <Card className="custom-card">
              <div
                className="cover-image"
                style={{ backgroundColor: "rgb(29, 155, 240)" }}
              ></div>
              <div className="profile-image">
                <img
                  src={
                    userAllDetails?.image
                      ? userAllDetails?.image
                      : `https://ui-avatars.com/api/?background=random&name=${
                          userAllDetails?.first_name +
                          " " +
                          userAllDetails?.last_name
                        }`
                  }
                  onClick={() =>
                    showLightBox(
                      userAllDetails?.image
                        ? userAllDetails?.image
                        : `https://ui-avatars.com/api/?background=random&name=${
                            userAllDetails?.first_name +
                            " " +
                            userAllDetails?.last_name
                          }`
                    )
                  }
                  alt="Image Not Available"
                />
              </div>
              <br></br>

              <div className="row my-2 py-2">
                <div
                  className="userinfo col-md-12 "
                  style={{ paddingLeft: "20px" }}
                >
                  <div className="fst mt-3">
                    {" "}
                    <h3>
                      {" "}
                      {userAllDetails?.first_name +
                        " " +
                        userAllDetails?.last_name}{" "}
                    </h3>{" "}
                  </div>
                  <div className="row">
                    <div className="col-md-3 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Email: <span>{userAllDetails?.email}</span>{" "}
                      </p>{" "}
                    </div>
                    <div className="col-md-3 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Mobile No. <span> {userAllDetails?.phone} </span>{" "}
                      </p>{" "}
                    </div>

                    <div className="col-md-3 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Vehicle Type:{" "}
                        <span> {userAllDetails?.vehicleType} </span>{" "}
                      </p>{" "}
                    </div>

                    <div className="col-md-3 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Vehicle Information:{" "}
                        <span> {userAllDetails?.vehicleInformation} </span>{" "}
                      </p>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </Card>

            {/* Warehouse Selection Section */}
            <CardBody>
              <div className="mb-4">
                <h5
                  className="header-card-title"
                  style={{ margin: "0 0 auto", marginBottom: "10px" }}
                >
                  Select Warehouse
                </h5>

                {warehouseLoader ? (
                  <div className="text-center">
                    <Spinner color="primary" />
                    <p>Loading warehouses...</p>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped">
                      <thead>
                        <tr>
                          <th>Select</th>
                          {/* <th>S.No</th> */}
                          <th>Warehouse Name</th>
                          <th>Address</th>
                          <th>Country</th>
                          <th>Contact</th>
                        </tr>
                      </thead>
                      <tbody>
                        {warehouses.map((warehouse, index) => (
                          <tr key={warehouse._id}>
                            <td>
                              <input
                                type="radio"
                                name="warehouse"
                                value={warehouse._id}
                                checked={
                                  selectedWarehouse?._id === warehouse._id
                                }
                                onChange={handleWarehouseChange}
                                style={{ width: "18px", height: "18px" }}
                              />
                            </td>
                            {/* <td>{index + 1}</td> */}
                            <td>
                              <div className="d-flex gap-2 align-items-center">
                                {warehouse.logo && (
                                  <img
                                    src={warehouse.logo}
                                    alt="Warehouse"
                                    width="40px"
                                    height="40px"
                                    className="rounded-circle"
                                  />
                                )}
                                <span>{warehouse.name}</span>
                              </div>
                            </td>
                            <td>
                              {warehouse.addressLine1}
                              {warehouse.addressLine2 &&
                                `, ${warehouse.addressLine2}`}
                              {warehouse.city && `, ${warehouse.city}`}
                              {warehouse.state && `, ${warehouse.state}`}
                              {warehouse.pincode && ` - ${warehouse.pincode}`}
                            </td>
                            <td>{warehouse.country}</td>
                            <td>
                              {warehouse.phone}
                              {warehouse.email && <div>{warehouse.email}</div>}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

                {/* Display selected warehouse info */}
                {/* {selectedWarehouse && (
            <div className="mt-3 p-3 bg-light rounded">
              <h6>Selected Warehouse:</h6>
              <div className="d-flex align-items-center gap-3">
                {selectedWarehouse.logo && (
                  <img 
                    src={selectedWarehouse.logo} 
                    alt="Selected Warehouse" 
                    width="50px" 
                    height="50px"
                    className="rounded-circle"
                  />
                )}
                <div>
                  <strong>{selectedWarehouse.name}</strong>
                  <div>{selectedWarehouse.addressLine1}, {selectedWarehouse.city}</div>
                  <div>Contact: {selectedWarehouse.contactNumber}</div>
                </div>
              </div>
            </div>
          )} */}
              </div>
            </CardBody>

            <CardBody>
              <h5
                className="header-card-title"
                style={{ margin: "0 0 auto", marginBottom: "10px" }}
              >
                Selected Order Dispatch
              </h5>
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th tabindex="0">Order Id</th>
                    <th tabindex="0">User Name</th>
                    <th tabindex="0">Order Address</th>
                    <th tabindex="0">User Type</th>
                    <th tabindex="0">Order Status</th>
                    <th tabindex="0">Payment Status</th>
                    <th tabindex="0">Grand Total</th>
                    <th tabindex="0">Order Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="">
                    <td>{orderDataInfo?.orderId}</td>
                    <td>
                      <div className="d-flex gap-2">
                        {orderDataInfo?.userName}
                      </div>
                    </td>
                    <td>
                      <div className="d-flex gap-2 justify-content-center">
                        <div className="flex-product">
                          {orderDataInfo?.orderAddress}
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="d-flex gap-2">
                        <div className="flex-product">
                          {orderDataInfo?.userType === "user" ? (
                            <>SME</>
                          ) : (
                            <>Informal Retailer</>
                          )}
                        </div>
                      </div>
                    </td>
                    <td>
                      {orderDataInfo?.orderStatus === "cancelled" ? (
                        <h5 style={{ color: "#ec536c" }}></h5>
                      ) : (
                        <div className="status-order">
                          <h5
                            style={
                              orderDataInfo?.orderStatus === "cancelled"
                                ? { color: "#ec536c" }
                                : orderDataInfo?.orderStatus === "failed"
                                ? { color: "#ec536c" }
                                : orderDataInfo?.orderStatus === "pending"
                                ? { color: "rgb(255, 193, 7)" }
                                : orderDataInfo?.orderStatus === "assigned"
                                ? { color: "rgb(255, 193, 7)" }
                                : { color: "#4caf50" }
                            }
                          >
                            {orderDataInfo?.orderStatus}
                          </h5>
                        </div>
                      )}
                    </td>
                    <td>
                      {PaymentStatusFormatter2(orderDataInfo?.paymentStatus)}
                    </td>
                    <td>${orderDataInfo?.grandTotal}</td>
                    <td>
                      <div
                        className="d-flex gap-2 align-items-center"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        {moment(orderDataInfo?.createdAt).format(
                          "DD/MM/YYYY hh:mm"
                        )}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={8}>
                      <table className="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th tabIndex={0}>S.NO</th>
                            {manufacturersType !== "manufacturers" && (
                              <th tabIndex={0}>Manufacturer Info</th>
                            )}
                            <th tabIndex={0}>Product Image</th>
                            <th tabIndex={0}>Product Name</th>
                            {/* <th tabIndex={0}>Description	</th> */}
                            <th tabIndex={0}>Quantity</th>
                            <th tabIndex={0}>Price</th>
                            <th tabIndex={0}>Total Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {selectedProductsData?.map((item, index) => {
                            return (
                              <>
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  {manufacturersType !== "manufacturers" && (
                                    <td>
                                      <div className="d-flex gap-2 align-items-center">
                                        <Link
                                          to={`/manufacturers-details/${item?.manufacturer?._id}`}
                                        >
                                          <div style={{ width: "50px" }}>
                                            <img
                                              src={item?.manufacturer?.logo}
                                              width="50px"
                                            />
                                          </div>
                                        </Link>
                                        <div className="flex-product text-start">
                                          <Link
                                            to={`/manufacturers-details/${item?.manufacturer?._id}`}
                                            className="mb-0"
                                          >
                                            {item?.manufacturer?.companyName}
                                          </Link>
                                          {/* <p className="mb-0">{item?.manufacturer?.mobile}, </p> */}
                                          <p className="mb-0">
                                            {item?.manufacturer?.address}
                                          </p>
                                        </div>
                                      </div>
                                    </td>
                                  )}
                                  <td>
                                    <img
                                      src={item?.images?.[0]}
                                      alt="Not found Product"
                                      width="50px"
                                    />
                                  </td>
                                  <td>{item?.name}</td>
                                  <td>{item?.quantity}</td>
                                  <td>${item?.price}</td>
                                  <td>${item?.totalPrice}</td>
                                </tr>
                              </>
                            );
                          })}
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              {selectedProductData?.length > 0 && (
                <>
                  <h5
                    class="header-card-title"
                    style={{ margin: "0 0 auto", marginBottom: "10px" }}
                  >
                    Nearby Selected Deliveries
                  </h5>
                  <table className="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th tabIndex={0}>S.NO</th>
                        <th tabIndex={0}>Order ID</th>
                        <th tabIndex={0}>Manufacturer Info</th>
                        <th tabIndex={0}>Product Image</th>
                        <th tabIndex={0}>Product Name</th>
                        {/* <th tabIndex={0}>Description	</th> */}
                        <th tabIndex={0}>Quantity</th>
                        <th tabIndex={0}>Price</th>
                        <th tabIndex={0}>Total Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedProductData?.map((item, index) => {
                        return (
                          <>
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{item?.orderId}</td>
                              <td>
                                <div className="d-flex gap-2 align-items-center">
                                  <Link
                                    to={`/manufacturers-details/${item?.manufacturer?._id}`}
                                  >
                                    <div style={{ width: "50px" }}>
                                      <img
                                        src={item?.manufacturer?.logo}
                                        width="50px"
                                      />
                                    </div>
                                  </Link>
                                  <div className="flex-product text-start">
                                    <Link
                                      to={`/manufacturers-details/${item?.manufacturer?._id}`}
                                      className="mb-0"
                                    >
                                      {item?.manufacturer?.companyName}
                                    </Link>
                                    {/* <p className="mb-0">{item?.manufacturer?.mobile}, </p> */}
                                    <p className="mb-0">
                                      {item?.manufacturer?.address}
                                    </p>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <img
                                  src={item?.images?.[0]}
                                  alt="Not found Product"
                                  width="50px"
                                />
                              </td>
                              <td>{item?.name}</td>
                              <td>{item?.quantity}</td>
                              <td>${item?.price}</td>
                              <td>${item?.totalPrice}</td>
                            </tr>
                          </>
                        );
                      })}
                    </tbody>
                  </table>
                </>
              )}
              <div
                className="col-lg-12 d-flex justify-content-end"
                style={{ gap: "10px" }}
              >
                <a
                  href="javascript:void(0);"
                  onClick={() => handleApproved()}
                  class="btn btn-primary place"
                >
                  <i class="ri-download-2-line align-bottom me-1"></i>
                  Approve
                </a>
                <Link
                  to={`/user-order-details/${orderDataInfo?.orderId}`}
                  class="btn btn-danger place"
                  style={{ fontSize: "20px" }}
                >
                  <i class="ri-download-2-line align-bottom me-1"></i>
                  Revoke
                </Link>
              </div>
            </CardBody>

            <CardBody className="table-shorting confirm-section">
              <h5
                className="header-card-title"
                style={{ margin: "0 0 auto", marginBottom: "10px" }}
              >
                Nearby Deliveries
              </h5>
              <PaginationProvider
                pagination={paginationFactory({
                  page: currentFPage,
                  sizePerPage: sizePerPageOrg,
                  totalSize: totalPage,
                  custom: true,
                })}
              >
                {({ paginationProps, paginationTableProps }) => (
                  <>
                    <ToolkitProvider
                      keyField="_id"
                      data={Bannerdata}
                      columns={columns}
                    >
                      {(props) => (
                        <Row>
                          <Col className="col-lg-12 d-flex mb-3"></Col>

                          <Col className="col-lg-12 text-end">
                            <BootstrapTable
                              keyField="id"
                              onTableChange={handleTableChange}
                              remote={true}
                              classes="table-striped"
                              {...props.baseProps}
                              {...paginationTableProps}
                              expandRow={expandRow}
                            />
                          </Col>
                        </Row>
                      )}
                    </ToolkitProvider>

                    <Row>
                      <Col className="col-lg-12 text-end">
                        <div className="text-md-right">
                          <PaginationListStandalone {...paginationProps} />
                        </div>
                      </Col>
                    </Row>
                  </>
                )}
              </PaginationProvider>
            </CardBody>
          </>
        )}
      </Card>
    </React.Fragment>
  );
};
export default ConfirmOrderAssign;
